"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var utils_1 = require("../../../utils");
var StyledFlexGrid_1 = require("../StyledFlexGrid");
// InVision Link: https://isobar.invisionapp.com/share/KSOOZHB8TP2#/screens/326820802
var caculateColumnWidth = function (size) { return Math.round((size / 12) * 10e7) / 10e5; };
var getColumnStyle = function (span) {
    if (typeof span === 'number') {
        var width = caculateColumnWidth(span);
        return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      flex: 0 0 ", "%;\n      max-width: ", "%;\n    "], ["\n      flex: 0 0 ", "%;\n      max-width: ", "%;\n    "])), width, width);
    }
    if (span === 'auto') {
        return styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      flex: 0 0 auto;\n    "], ["\n      flex: 0 0 auto;\n    "])));
    }
    if (span === 'auto-grow') {
        return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      flex: 1 0 auto;\n    "], ["\n      flex: 1 0 auto;\n    "])));
    }
    // we check if true here because `if(number value)` still returns true
    if (span === true) {
        return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      flex: 1 0 0%;\n      max-width: 100%;\n    "], ["\n      flex: 1 0 0%;\n      max-width: 100%;\n    "])));
    }
};
var getGridItemStyle = function (size) {
    var style = [];
    if (typeof size === 'object') {
        if (typeof size.span !== 'undefined') {
            style.push(getColumnStyle(size.span));
        }
        if (typeof size.offset !== 'undefined') {
            var width = caculateColumnWidth(size.offset);
            style.push(styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n        margin-left: ", "%;\n      "], ["\n        margin-left: ", "%;\n      "])), width));
        }
    }
    else {
        style.push(getColumnStyle(size));
    }
    return style;
};
var paddingStyle = function (theme) {
    var breakpoints = theme.global.breakpoints;
    var styles = [
        styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])))
    ];
    Object.keys(theme.flexGrid.breakpoints).forEach(function (breakpoint) {
        styles.push(utils_1.addBreakpoint(breakpoints[breakpoint], "padding: 0px " + StyledFlexGrid_1.getGutter(breakpoint, theme) + "px", 'up'));
    });
    return styles;
};
exports.StyledFlexGridItem = styled_components_1.default.div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  box-sizing: border-box;\n  margin: 0;\n  ", "\n  ", "\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  margin: 0;\n  ", "\n  ", "\n\n  ",
    "\n"])), function (props) { return paddingStyle(props.theme); }, utils_1.genericStyles, function (props) {
    var breakpoints = props.theme.global.breakpoints;
    return styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      ", "\n      ", "\n      ", "\n      ", "\n    "], ["\n      ", "\n      ", "\n      ", "\n      ", "\n    "])), props.xs && utils_1.addBreakpoint(breakpoints.xs, getGridItemStyle(props.xs), 'up'), props.sm && utils_1.addBreakpoint(breakpoints.sm, getGridItemStyle(props.sm), 'up'), props.md && utils_1.addBreakpoint(breakpoints.md, getGridItemStyle(props.md), 'up'), props.lg && utils_1.addBreakpoint(breakpoints.lg, getGridItemStyle(props.lg), 'up'));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=StyledFlexGridItem.js.map